import React from "react";
import { tokens } from "@blurb/codex-react";
import { ICON_CODEPOINTS, type IconName } from "./iconCodepoints.generated";

export interface IconV3Props {
  icon: IconName;
  size?: string | number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  /** Icons are decorative by default; pass false and a label when one carries meaning alone. */
  "aria-hidden"?: React.AriaAttributes["aria-hidden"];
  "aria-label"?: string;
}

// See developer integration guide for more info: https://developers.google.com/fonts/docs/material_symbols
//
// `icon` is limited to the glyphs bundled in the subsetted font — add new ones to
// icon-names.json and run `npm run generate-icons` in this package. The glyph is
// emitted as a codepoint because the font is subsetted by codepoint, so the
// ligature names the upstream font uses would not resolve.
export const IconV3: React.FC<IconV3Props> = ({
  icon,
  size = 24,
  color,
  className,
  style,
  "aria-hidden": ariaHidden = true,
  "aria-label": ariaLabel,
}) => {
  const finalColor = color || tokens.color.semantic.icon.bold;
  return (
    <span
      className={`material-symbols-rounded ${className || ""}`}
      style={{
        fontSize: size,
        color: finalColor,
        display: "inline-block",
        lineHeight: 1,
        ...style,
      }}
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      role={ariaLabel ? "img" : undefined}
    >
      {String.fromCodePoint(ICON_CODEPOINTS[icon])}
    </span>
  );
};
